import { createIdentifier } from '@wix/thunderbolt-ioc'

export interface IDomSelectors {
	getByCompId(compId: string, doc?: Document): HTMLElement | null
	getClosestByCompId(element: Element, compId: string): Element | null
	querySelector(selector: string, doc?: Document, element?: Element): Element | null
	querySelectorAll(selector: string, doc?: Document, element?: Element): Element[]
	getElementCompId(element: Element): string
}

export const DomSelectorsSymbol = createIdentifier<IDomSelectors>(Symbol('DomSelectors'))
